import Vue from 'vue'
import 'sspai-ui/lib/sspai-ui.css'
import { formatImage } from 'sspai-ui/lib/utils'
import {
  Message,
  Dialog,
  Button
} from 'element-ui'
import {
  // base
  SsAvatar,
  SsButton,
  SsButton2,
  SsFeaturePopover,
  // SsInput,
  SsPortrait,
  // SsCustomHeaderLogo,
  SsUserIdentifier,
  // SsUserPrimeCard,
  // SsPrimeLogo,
  SsDialog2,
  SsUserNickname,
  // login
  // SsAreaCodeSelect,
  // SsPhoneInput,
  // SsPasswordInput,
  // SsSlideVerification,
  // SsVerificationCode,
  // SsLogin,
  // SsLoginDialog,
  SsLoginRequired,
  // header
  SsCustomHeader,
  // SsCustomHeaderUser,
  // SsCustomHeaderNotice,
  // SsNotificationsPopover,
  // footer
  SsCustomFooter,
  // comment
  SsReport,
  SsCommentConvention,
  SsCommentInquire
} from 'sspai-ui'

import * as golbalMethod from 'sspai-ui/lib/utils'
import * as golbalFilter from 'sspai-ui/lib/filters'
import * as golbalDerective from 'sspai-ui/lib/directives'

Vue.use(Dialog)
Vue.use(Button)
// 基础组件
Vue.use(SsAvatar)
Vue.use(SsButton)
Vue.use(SsButton2)
Vue.use(SsFeaturePopover)
// Vue.use(SsInput)
Vue.use(SsPortrait)
// Vue.use(SsCustomHeaderLogo)
Vue.use(SsUserIdentifier)
// Vue.use(SsUserPrimeCard)
// Vue.use(SsPrimeLogo)
Vue.use(SsDialog2)
Vue.use(SsUserNickname)
// 登录相关组件
// Vue.use(SsAreaCodeSelect)
// Vue.use(SsPhoneInput)
// Vue.use(SsPasswordInput)
// Vue.use(SsSlideVerification)
// Vue.use(SsVerificationCode)
// Vue.use(SsLogin)
// Vue.use(SsLoginDialog)
// 头部相关组件
Vue.use(SsCustomHeader)
// Vue.use(SsCustomHeaderUser)
// Vue.use(SsCustomHeaderNotice)
// Vue.use(SsNotificationsPopover)
// 底部相关组件
Vue.use(SsCustomFooter)

// 遍历注册全局方法
Object.keys(golbalMethod).forEach((key) => {
  Vue.prototype[`$${key}`] = golbalMethod[key]
  if (typeof window !== 'undefined') {
    window[`$${key}`] = golbalMethod[key]
  }
})
// 遍历注册过滤器方法
Object.keys(golbalFilter).forEach((key) => {
  Vue.filter(key, golbalFilter[key])
})
// 遍历注册自定义指令
Object.keys(golbalDerective).forEach((key) => {
  Vue.directive(key, golbalDerective[key])
})

export const CustomToast = (options) => {
  options = options || {}
  if (typeof options === 'string') {
    options = {
      message: options
    }
  }
  options.customClass = 'ss__toast'
  options.iconClass = `ssCommunityIcon__${options.type || 'info'}`
  return Message(options)
}

Vue.prototype.$ReportDialog = SsReport
Vue.prototype.$CommentConvention = SsCommentConvention
Vue.prototype.$keepCommentDeletedPlaceholder = SsCommentInquire
Vue.prototype.$loginRequired = SsLoginRequired
Vue.prototype.$toast = CustomToast
Vue.prototype.$formatImageSrc = formatImage.bind(
  null,
  window.isSupportWebp,
  process.env.VUE_APP_IMAGE_URL
)
